import { AxiosResponse } from 'axios';
import { useTranslation } from 'react-i18next';
import { TFunction } from 'i18next';

export interface ApiError extends Error {
  displayMessage?: string;
  response?: AxiosResponse;
}

export const parseApiErrorMsg = (t: TFunction, error?: ApiError): string => {
  if (error?.displayMessage) {
    return error.displayMessage;
  }
  return t('Tanium Account is temporarily unavailable or undergoing maintenance.');
};

export const useApiErrorMsgParser = (error?: ApiError): string => {
  const { t } = useTranslation();
  return parseApiErrorMsg(t, error);
};
